import React, { useState } from "react"
import { Button, FormField, FullScreenLoadingCover, Modal } from "@prosolve/common-components-ui"
import useForm from "../../hooks/useForm"
import useDataUserAccount from "../../dataHooks/useDataUserAccount"
import useSnackbar from "../../hooks/useSnackbar"

export default ({
  userAccount,
  onClose
}) => {
  const [message, setMessage] = useState('')

  const { newMessage } = useSnackbar()
  const { isLoading, updateUserAccount } = useDataUserAccount()

  const formSchema = {
    requiredFields: ['currentPassword', 'newPassword', 'confirmPassword'],
    optionalFields: [],
    initData: {}
  }
  const formData = useForm(formSchema)

  const handleSubmit = async () => {
    if (formData.isValid()) {
      const { newPassword, confirmPassword } = formData.values

      if (newPassword !== confirmPassword) {
        setMessage('New password and confirm password do not match')

      } else if (newPassword.length < 8) {
        setMessage('New password must be at least 8 characters long')

      } else {
        const result = await updateUserAccount(formData.values)

        if (!result.status) {
          newMessage({ message: result.message || 'Error updating password', severity: 'failure' })
        } else {
          newMessage({ message: 'Password updated successfully', severity: 'success' })
          onClose()
        }
      }
    }
  }

  return (
    <Modal 
      title='Change Password'
      onClose={onClose} 
      isAutoWidth={true}
      isAutoHeight={true}
      footer={(
        <div style={{ 
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          columnGap: '10px',
          padding: '10px'
        }}>
          <Button onClick={onClose}>
            {'Cancel'}
          </Button>
          <Button onClick={handleSubmit} $colored={true}>
            {'Change Password'}
          </Button>
        </div>
      )}
    >
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '20px'
      }}>
        <div>
          {'To change your password, first enter your current password and then enter your new password.'}
        </div>
        <FormField
          style={{ flex: 1 }}
          fieldId='currentPassword'
          type='password'
          label='Current Password'
          placeholder='Enter Current Password'
          formData={formData}
        />
        <FormField
          style={{ flex: 1 }}
          fieldId='newPassword'
          type='password'
          label='New Password'
          placeholder='Enter New Password'
          formData={formData}
        />
        <FormField
          style={{ flex: 1 }}
          fieldId='confirmPassword'
          type='password'
          label='Confirm Password'
          placeholder='Confirm New Password'
          formData={formData}
        />
        <div style={{ color: 'red' }}>{message}</div>
      </div>
      {isLoading &&
        <FullScreenLoadingCover />
      }
    </Modal>
  )
}
